export const businessGameBasics = {
  date: '23 июня 2026 года',
  time: '11:00-14:00',
  format: 'Очный формат',
  price: 'Вход свободный',
  place: 'г. Пермь, ул. Ленина, 70',
  placeDetails: 'Пермская государственная краевая универсальная библиотека им. А.М. Горького',
};

export const discussionTopics = [
  {
    title: 'Закупки у единственного поставщика',
    description: 'Когда формат ЕП помогает, где появляются риски дробления и как это видят обе стороны закупки.',
    tag: 'ЕП',
  },
  {
    title: 'Приемка ТРУ',
    description: 'Поставка товара, несоответствие условиям контракта, приемка работ и последствия для заказчика и поставщика.',
    tag: 'ТРУ',
  },
  {
    title: 'Техническое задание',
    description: 'Как описывать потребность через функциональные характеристики и снижать риск оспаривания закупки.',
    tag: 'ТЗ',
  },
  {
    title: 'НМЦК и выбор производителя',
    description: 'Подходы к обоснованию цены, потребности и выбора конкретного решения без лишних обещаний и упрощений.',
    tag: 'НМЦК',
  },
];

export const roleCards = [
  {
    title: 'Команда заказчика',
    description: 'Формулирует потребность, готовит документацию, защищает логику ТЗ и способ закупки.',
    items: ['руководитель закупочной деятельности', 'специалист по закупкам', 'технический эксперт'],
  },
  {
    title: 'Команда поставщиков',
    description: 'Анализирует документацию, ищет признаки ограничения конкуренции и предлагает корректировки.',
    items: ['поставщик желаемого производителя', 'альтернативный поставщик', 'юрист поставщика'],
  },
  {
    title: 'Арбитражная команда',
    description: 'Смотрит на ситуацию через требования 44-ФЗ и 223-ФЗ, фиксирует ошибки и рекомендации.',
    items: ['эксперт по 44-ФЗ', 'эксперт по 223-ФЗ', 'разбор правовых рисков'],
  },
];

export const programBlocks = [
  {
    time: '11:00-12:00',
    title: 'Дискуссионное обсуждение',
    items: [
      'возможные конфликты заказчика и поставщика',
      'закупки у единственного поставщика и риски злоупотребления',
      'проблемы приемки товара, работ и услуг',
    ],
  },
  {
    time: '12:00-13:30',
    title: 'Деловая игра',
    items: [
      'постановка кейсовой ситуации и распределение ролей',
      'работа с техническим заданием, НМЦК и документацией',
      'ролевая встреча «Согласование ТЗ»',
    ],
  },
  {
    time: '13:30-14:00',
    title: 'Итоги и обратная связь',
    items: [
      'анализ решений арбитражной командой',
      'обсуждение рисков ограничения конкуренции',
      'рекомендации экспертов и ответы на вопросы',
    ],
  },
];

export const faqItems = [
  {
    question: 'Кому подойдет деловая игра?',
    answer: 'Заказчикам, специалистам по закупкам, контрактным управляющим, поставщикам и B2G-командам, которым важно понимать логику другой стороны закупочного процесса.',
  },
  {
    question: 'Нужно ли приходить уже с командой?',
    answer: 'Нет. Можно зарегистрироваться одному, а коллегу лучше зарегистрировать заранее отдельной заявкой. Так организаторы смогут точнее рассчитать количество участников до начала мероприятия.',
  },
  {
    question: 'Это обучение или консультация по конкретной закупке?',
    answer: 'Это практическое обучающее мероприятие на кейсовой ситуации. Эксперты разбирают подходы, риски и варианты действий, но не заменяют индивидуальную юридическую экспертизу конкретной закупки.',
  },
  {
    question: 'Сколько стоит участие?',
    answer: 'Участие бесплатное, но требуется предварительная регистрация. Количество мест ограничено вместимостью площадки.',
  },
  {
    question: 'Что будет после регистрации?',
    answer: 'Команда АБВЗАКУПКИ свяжется с вами, подтвердит участие и направит организационную информацию по месту и времени проведения.',
  },
];
